import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { IdListEditRequest } from 'src/types/rest/tenant';

export const useUpdateTenantUsers = (tenantId: string) => {
  const queryClient = useQueryClient();

  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: (variables: IdListEditRequest) =>
      apiRequest<void>({
        data: variables,
        method: 'PATCH',
        url: `${apiHost}/tenants/${tenantId}/users`,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['tenant', tenantId, 'users'],
      });
    },
  });
};
